import { useEffect, useState } from "react"
import { useLocation, useRouteMatch } from "react-router-dom";
import { AppTester } from "supporting";

export const useGetShowcaseContext = (): Array<string | string[]> => {
    const [context, setContext] = useState<string | string[]>([]);
    const location = useLocation();
    const isTeamRoute = useRouteMatch('/teams/');

    useEffect(() => {
        let ctx: string | string[] = '';

        if (
            AppTester.isHSEDesign()
        ) {
            ctx = isTeamRoute ? location.pathname.split('/')?.[2] : 'hsedesign';
        }
        if (AppTester.isLectureMediiia()) {
            ctx = 'medialecture';
        }
        if (AppTester.isBrnd()) {
            ctx = 'brnd';
        }
        if (AppTester.isAgeytomesh()) {
            ctx = 'ageytomesh';
        }
        if (AppTester.isGalllleryArt()) {
            ctx = 'galllleryart';
        }
        if (AppTester.isSuperPuper()) {
            ctx = [
                'super-puper-collection', 
                'super-puper-collection-parent'
            ];
        }
        if (AppTester.isFashionDeziiign()) {
            ctx = 'fashiondeziiign';
        }
        if (
            AppTester.isProDeziiign() && 
            !AppTester.isLectureMediiia()
        ) {
            ctx = 'propresentation';
        }
        if (AppTester.isProHSE()) {
            ctx = 'prohse';
        }
        if (AppTester.isLMSHSE()) {
            ctx = 'hsecourses';
        }
        if (AppTester.isGeoDafes()) {
            ctx = 'dafes';
        }

        setContext(ctx);
    }, [isTeamRoute, location])

    return [context];
}import { useEffect, useState } from "react"
import { useLocation, useRouteMatch } from "react-router-dom";
import { AppTester } from "supporting";

export const useGetShowcaseContext = (): Array<string | string[]> => {
    const [context, setContext] = useState<string | string[]>([]);
    const location = useLocation();
    const isTeamRoute = useRouteMatch('/teams/');

    useEffect(() => {
        let ctx: string | string[] = '';

        if (
            AppTester.isHSEDesign()
        ) {
            ctx = isTeamRoute ? location.pathname.split('/')?.[2] : 'hsedesign';
        }
        if (AppTester.isLectureMediiia()) {
            ctx = 'medialecture';
        }
        if (AppTester.isBrnd()) {
            ctx = 'brnd';
        }
        if (AppTester.isAgeytomesh()) {
            ctx = 'ageytomesh';
        }
        if (AppTester.isGalllleryArt()) {
            ctx = 'galllleryart';
        }
        if (AppTester.isSuperPuper()) {
            ctx = [
                'super-puper-collection', 
                'super-puper-collection-parent'
            ];
        }
        if (AppTester.isFashionDeziiign()) {
            ctx = 'fashiondeziiign';
        }
        if (
            AppTester.isProDeziiign() && 
            !AppTester.isLectureMediiia()
        ) {
            ctx = 'propresentation';
        }
        if (AppTester.isProHSE()) {
            ctx = 'prohse';
        }
        if (AppTester.isLMSHSE()) {
            ctx = 'hsecourses';
        }
        if (AppTester.isGeoDafes()) {
            ctx = 'dafes';
        }

        setContext(ctx);
    }, [isTeamRoute, location])

    return [context];
}